/*
 * FavoritePage Messages
 *
 * This contains all the text for the FavoritePage container.
 */

import { defineMessages } from 'react-intl';

export const scope = 'app.containers.FavoritePage';

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: 'Sản phẩm yêu thích',
  },
  allSupplier: {
    id: `${scope}.allSupplier`,
    defaultMessage: 'Tất cả nhà cung cấp',
  },
  noFavotite: {
    id: `${scope}.noFavotite`,
    defaultMessage: 'Không có sản phẩm yêu thích',
  },
  gotoMartMessage: {
    id: `${scope}.gotoMartMessage`,
    defaultMessage: 'Vào chợ và tạo danh sách sản phẩm yêu thích !!',
  },
  filterBySupplier: {
    id: `${scope}.filterBySupplier`,
    defaultMessage: 'Lọc theo nhà cung cấp',
  },
  inCart: {
    id: `${scope}.inCart`,
    defaultMessage: 'trong giỏ hàng',
  },
  apply: {
    id: `${scope}.apply`,
    defaultMessage: 'Đồng ý',
  },
});
